import CONSTANTS from '@/constants'
import { clearTokens } from './tokenHandling'
import router from '../router'
import store from '../store'

const fallbackMessage = 'Network error. Cannot reach INE services.'
const fallbackStatus = 503

const createFriendlyError = message => {
  return CONSTANTS.FRIENDLY_ERRORS[message] ?? message
}

const handleExpiredSession = () => {
  clearTokens()
  const query = {
    error: 'Your session has expired. Please login to continue.',
  }
  if (store?.state?.auth?.redirectUrl) {
    query.redirect_url = store.state.auth.redirectUrl
  }
  router.push({
    name: 'login',
    query,
  })
}

const rmotrErrorHandler = errorObj => {
  const status = errorObj?.response?.status ?? fallbackStatus
  const message = errorObj?.response?.data?.detail ?? fallbackMessage
  if (CONSTANTS.KNOWN_API_ERRORS.REQUIRES_REAUTHENTICATION.includes(message)) {
    handleExpiredSession()
    return null
  }
  if (errorObj?.response?.data) {
    return {
      ...errorObj.response.data,
      http_code: status,
      message: createFriendlyError(message),
    }
  }
  return { http_code: status, message: createFriendlyError(message) }
}

const ineErrorHandler = errorObj => {
  const status = errorObj?.response?.status ?? fallbackStatus
  const message = errorObj?.response?.data?.error?.message ?? fallbackMessage
  if (errorObj?.response?.data?.error) {
    return {
      ...errorObj.response.data.error,
      message: createFriendlyError(message),
    }
  }
  return {
    http_code: status,
    message: createFriendlyError(message),
  }
}

export { rmotrErrorHandler, ineErrorHandler }
